<app-header></app-header>
<app-navbar [selected]="'administration'"></app-navbar>
<app-sidebar [items]="links"></app-sidebar>
